import { ApolloClient, createHttpLink, InMemoryCache, ApolloLink } from "@apollo/client";

const responseLogger = new ApolloLink((operation, forward) => {
  return forward(operation).map(result => {
    //if url search params contains 'debug' then log the response operation
    new URLSearchParams(window.location.search).get("debug") === "true" && console.info(operation);
    return result
  })
})

export const apolloClient = new ApolloClient({
  link: ApolloLink.from([
    responseLogger,
    createHttpLink({
      uri: process.env.REACT_APP_RESALYS_API_URI + "/rsl/graphql?base_id=" + process.env.REACT_APP_RSL_BASEID!!,
      /*fetchOptions: {
        mode: 'no-cors',
      },*/
      headers: {
        "Content-Type": "application/json;charset=utf-8",
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Credentials": "true",
      },
    }),
  ]),
  cache: new InMemoryCache(),
});
